/* eslint-disable react/jsx-key */

import React from 'react';
import { createIcon } from '@chakra-ui/icons';

export const SuccessIllustration = createIcon({
  displayName: 'SuccessIllustration',
  viewBox: '0 0 196 133',
  path: [
    <svg
      width="196"
      height="133"
      viewBox="0 0 196 133"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <ellipse cx="103.457" cy="125" rx="42.5" ry="8" fill="#C2DBF2" fillOpacity="0.5" />
      <path
        d="M128.762 57.5058L129.252 57.6033L128.762 57.5058C128.628 58.1804 129.199 58.786 129.881 58.6913L136.714 57.7415L133.844 64.0152C133.558 64.6407 133.974 65.3617 134.659 65.4267L141.527 66.0783L137.288 71.5211C136.865 72.0638 137.104 72.8613 137.755 73.0825L144.288 75.3004L138.908 79.6189C138.371 80.0495 138.42 80.8806 139.003 81.246L144.848 84.9107L138.617 87.8721C137.995 88.1673 137.851 88.9872 138.334 89.4772L143.176 94.391L136.43 95.8356C135.757 95.9796 135.428 96.744 135.785 97.3321L139.363 103.23L132.466 103.08C131.778 103.065 131.281 103.733 131.493 104.388L133.615 110.952L126.938 109.215C126.272 109.042 125.634 109.577 125.689 110.263L126.24 117.14L120.144 113.91C119.536 113.588 118.792 113.962 118.688 114.642L117.638 121.46L112.451 116.912C111.933 116.458 111.123 116.65 110.865 117.288L108.271 123.68L104.272 118.058C103.874 117.498 103.041 117.498 102.642 118.058L98.644 123.68L96.05 117.288C95.7913 116.65 94.9812 116.458 94.464 116.912L89.2769 121.46L88.2271 114.642C88.1224 113.962 87.3784 113.588 86.7706 113.91L87.0046 114.352L86.7706 113.91L80.6743 117.14L81.2252 110.263C81.2801 109.577 80.6424 109.042 79.9767 109.215L73.2999 110.952L75.4219 104.388C75.6335 103.733 75.1364 103.065 74.4486 103.08L67.5514 103.23L71.13 97.3321C71.4868 96.744 71.1571 95.9796 70.4844 95.8356L63.7385 94.391L68.5808 89.4772C69.0637 88.9872 68.9191 88.1673 68.2978 87.8721L62.0668 84.9107L67.9119 81.246C68.4947 80.8806 68.5431 80.0495 68.0067 79.6189L62.6266 75.3004L69.1592 73.0825C69.8106 72.8614 70.0494 72.0638 69.6267 71.5211L65.3875 66.0783L72.2555 65.4267C72.9404 65.3617 73.3566 64.6407 73.0705 64.0152L70.2008 57.7415L77.034 58.6913C77.7153 58.786 78.2866 58.1804 78.1525 57.5058L76.8069 50.7394L83.2369 53.2394C83.878 53.4887 84.5736 53.0312 84.5986 52.3438L84.8498 45.4495L90.5299 49.365C91.0963 49.7554 91.8785 49.4707 92.0615 48.8075L93.8958 42.157L98.5198 47.2769C98.9809 47.7874 99.8077 47.6907 100.139 47.0877L103.457 41.0394L106.776 47.0877C107.107 47.6907 107.934 47.7874 108.395 47.2769L113.019 42.157L114.853 48.8075C115.036 49.4707 115.818 49.7554 116.385 49.365L122.065 45.4495L122.316 52.3438C122.341 53.0312 123.037 53.4887 123.678 53.2394L130.108 50.7394L128.762 57.5058Z"
        fill="#C2DBF2"
        stroke="#1962A6"
      />
      <path
        d="M96.1036 92.8532L96.4572 93.2068L96.8107 92.8532L121.561 68.1032L121.563 68.1011C121.745 67.9165 121.962 67.77 122.202 67.67C122.441 67.57 122.698 67.5186 122.957 67.5186C123.217 67.5186 123.473 67.57 123.713 67.67C123.952 67.77 124.169 67.9165 124.351 68.1011L124.351 68.1011L124.356 68.1053C124.54 68.2876 124.687 68.5048 124.787 68.7441C124.887 68.9834 124.938 69.2403 124.938 69.4997C124.938 69.759 124.887 70.0159 124.787 70.2552C124.687 70.4945 124.54 70.7117 124.356 70.894L124.354 70.8959L97.8538 97.3709L97.8536 97.3711C97.0739 98.1508 95.8155 98.1508 95.0357 97.3711L84.5607 86.8961L84.5586 86.894C84.3741 86.7117 84.2275 86.4945 84.1276 86.2552C84.0276 86.0159 83.9761 85.759 83.9761 85.4997C83.9761 85.2403 84.0276 84.9835 84.1276 84.7441C84.2275 84.5048 84.374 84.2876 84.5586 84.1053L84.5586 84.1054L84.5629 84.1011C84.7452 83.9165 84.9623 83.77 85.2016 83.67C85.441 83.57 85.6978 83.5186 85.9572 83.5186C86.2166 83.5186 86.4734 83.57 86.7127 83.67C86.9521 83.77 87.1692 83.9165 87.3515 84.1011L87.3536 84.1032L96.1036 92.8532Z"
        fill="#0269CA"
        stroke="#0269CA"
      />
      <rect
        x="2.80298"
        y="48"
        width="4"
        height="4"
        transform="rotate(27.4798 2.80298 48)"
        fill="#8F00FF"
      />
      <rect
        x="69.9573"
        y="2.30273"
        width="4"
        height="4"
        transform="rotate(-35.1555 69.9573 2.30273)"
        fill="#0269CA"
      />
      <rect
        x="183.957"
        y="24.3672"
        width="8"
        height="8"
        transform="rotate(-17.2106 183.957 24.3672)"
        fill="#EBD1FF"
      />
      <path
        d="M56.9573 29L57.6308 31.0729H59.8104L58.0471 32.3541L58.7206 34.4271L56.9573 33.1459L55.1939 34.4271L55.8675 32.3541L54.1041 31.0729H56.2837L56.9573 29Z"
        fill="#C2DBF2"
      />
      <path
        d="M32.3495 63.3056L32.2962 66.2113L35.0433 67.1599L32.2633 68.0071L32.21 70.9128L30.5452 68.5307L27.7653 69.3779L29.5163 67.0585L27.8515 64.6765L30.5985 65.625L32.3495 63.3056Z"
        fill="#FFC793"
      />
      <path
        d="M193.152 67.6528L193.126 69.1056L194.499 69.5799L193.109 70.0035L193.083 71.4564L192.25 70.2654L190.86 70.689L191.736 69.5293L190.903 68.3382L192.277 68.8125L193.152 67.6528Z"
        fill="#70A0CC"
      />
      <path d="M104.231 32.6998L104.804 36.1162L101.559 34.9041L104.231 32.6998Z" fill="#B350FF" />
      <path d="M121.523 11.8135L127.33 15.5908L121.155 18.7319L121.523 11.8135Z" fill="#1962A6" />
      <path d="M164.957 85L168.421 91H161.493L164.957 85Z" fill="#FFE7D1" />
      <circle cx="164.957" cy="52" r="2" fill="#1962A6" />
      <circle cx="15.9573" cy="100" r="4" fill="#B898D9" />
    </svg>,
  ],
});
